export default __webpack_public_path__ + "static/neckband-656c8412147f2b075dde2d75549c1ef7.png";